var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84775 5.25449L12.7107 7.90713L12.7244 7.76818C12.7244 6.37448 11.5019 5.24186 9.99771 5.24186L9.84775 5.25449Z",
    fill: "#B6CDE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99772 3.55767C12.5062 3.55767 14.5421 5.444 14.5421 7.76822C14.5421 8.31137 14.424 8.82927 14.2195 9.30505L16.878 11.7682C18.2504 10.7072 19.332 9.33453 20 7.76822C18.4231 4.07139 14.5467 1.45242 9.99776 1.45242C8.72531 1.45242 7.50744 1.66294 6.37588 2.04188L8.33906 3.85661C8.85253 3.67136 9.41149 3.55767 9.99772 3.55767Z",
    fill: "#B6CDE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.908868 1.26291L2.98112 3.18291L3.39468 3.56608C1.89502 4.6524 0.708928 6.09662 0 7.76818C1.57238 11.465 5.4533 14.084 9.99772 14.084C11.4065 14.084 12.7516 13.8313 13.9832 13.3724L14.3695 13.7303L17.0189 16.1892L18.1777 15.1198L2.06769 0.189224L0.908868 1.26291ZM5.93502 5.91556L7.33924 7.21661C7.29834 7.39768 7.27107 7.5787 7.27107 7.76818C7.27107 9.16188 8.49351 10.2945 9.99772 10.2945C10.2022 10.2945 10.3976 10.2692 10.5885 10.2313L11.9927 11.5324C11.3883 11.8103 10.7158 11.9787 9.99772 11.9787C7.48921 11.9787 5.45329 10.0924 5.45329 7.76818C5.45329 7.10293 5.63509 6.47976 5.93502 5.91556Z",
    fill: "#B6CDE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eyeOff.a2640b6da601cb9a1b1d80f4a9880154.svg";
export { ForwardRef as ReactComponent };